exports.components = {
  "component---src-pages-editor-tsx": () => import("./../../../src/pages/editor.tsx" /* webpackChunkName: "component---src-pages-editor-tsx" */),
  "component---src-pages-iframetable-tsx": () => import("./../../../src/pages/iframetable.tsx" /* webpackChunkName: "component---src-pages-iframetable-tsx" */),
  "component---src-pages-maintenance-tsx": () => import("./../../../src/pages/maintenance.tsx" /* webpackChunkName: "component---src-pages-maintenance-tsx" */),
  "component---src-templates-storyblok-entry-tsx": () => import("./../../../src/templates/storyblokEntry.tsx" /* webpackChunkName: "component---src-templates-storyblok-entry-tsx" */)
}

